import { TFunction } from 'i18next'

import { FeatureType } from '@wwt/entities/api/search-response'
import { Feature, FeatureOptions } from '@wwt/entities/search-response'
import { capitalizeFirstLetter } from '@wwt/shared/utils/capitalizeFirstLetter'

import { NO_NAME } from '@/shared/config/NO_NAME'

import { FeatureTooltipInfo } from '../types/FeatureTooltipInfo'
import { getTooltipIconType } from './getTooltipIconType'
import { getTooltipIconsDetails } from './getTooltipIconsDetails'

/**
 * Util for generate tooltip info for feature
 *
 * @author Ivan Shchedrovskyi
 * TODO: Refactor
 */
export const getFeatureTooltipInfo = (
	feature: Feature,
	selectedOption: FeatureOptions,
	t: TFunction<'tooltips', undefined>,
	showSelectedOption?: boolean,
	showFeatureName?: boolean
): FeatureTooltipInfo => {
	const defaultFeatureTooltip: FeatureTooltipInfo = {
		hasTooltip: false,
		tooltipTitle: '-',
		tooltipText: '-',
		tooltipImageUrl: '-'
	}

	const isCheckInFeature = feature.type === FeatureType.checkIn

	const tooltipIconType = getTooltipIconType(isCheckInFeature, selectedOption)
	const tooltipIconsDetails = getTooltipIconsDetails(
		isCheckInFeature,
		selectedOption,
		t
	)

	if (showSelectedOption) {
		if (showFeatureName) {
			const optionName =
				selectedOption.name === NO_NAME
					? ''
					: ': ' + capitalizeFirstLetter(selectedOption.name)

			return {
				hasTooltip: Boolean(
					selectedOption.description ||
						feature.description ||
						tooltipIconsDetails.length > 0
				),
				tooltipTitle: capitalizeFirstLetter(feature.name) + optionName,
				tooltipText: selectedOption.description ?? feature.description,
				tooltipImageUrl: selectedOption.imageUrl ?? feature.imageUrl,
				tooltipIconType: tooltipIconType,
				tooltipIconsDetails: tooltipIconsDetails
			}
		}

		return {
			hasTooltip: Boolean(
				selectedOption.description || tooltipIconsDetails.length > 0
			),
			tooltipTitle: capitalizeFirstLetter(selectedOption.name),
			tooltipText: selectedOption.description,
			tooltipImageUrl: selectedOption.imageUrl,
			tooltipIconType: tooltipIconType,
			tooltipIconsDetails: tooltipIconsDetails
		}
	}

	if (showFeatureName) {
		return {
			hasTooltip: Boolean(feature.description),
			tooltipTitle: capitalizeFirstLetter(feature.name),
			tooltipText: feature.description,
			tooltipImageUrl: feature.imageUrl,
			tooltipIconType: tooltipIconType,
			tooltipIconsDetails: tooltipIconsDetails
		}
	}

	return defaultFeatureTooltip
}
